import { BoxModel } from '@fox/blocks/contracts/box-model';
import { DIVIDER_BLOCK_TYPE } from '@fox/blocks/contracts/block-types';
import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { getAttributeValues, transformLegacyProps } from '../../../utils';

export interface DividerBlockProps {
	colour?: string;
	attributes?: {
		padding?: BoxModel;
	};
}

export function DividerBlock({ props, type }: IBlockProps<DividerBlockProps>) {
	const {
		attributes: { padding }
	} = transformLegacyProps(type, props);
	const { top: paddingTop, bottom: paddingBottom, right: paddingRight, left: paddingLeft } = getAttributeValues(padding);
	return (
		<div
			style={{
				paddingTop: paddingTop,
				paddingRight: paddingRight,
				paddingBottom: paddingBottom,
				paddingLeft: paddingLeft,
				width: '100%'
			}}
		>
			<div
				style={{
					width: '100%',
					height: 4,
					backgroundColor: props.colour ?? '#99adc0'
				}}
			></div>
		</div>
	);
}

export const DividerBlockRuntime: IBlockDefinition<DividerBlockProps> = {
	type: DIVIDER_BLOCK_TYPE,
	Component: DividerBlock
};
